import { Card, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import sponsorImage from "../../assets/icons/user-sponsor.svg";
import Inputs from "../Inputs/Inputs";
import PrimaryButton from "../Buttons/PrimaryButton";
import ProgressCard from "../progress/ProgressCard";

interface PropsSponsorOrphanCard {
  data: any;
  updateValue: (item: any) => void;
  removeValue: (item: any) => void;
  defaultItem: any;
}

const SponsorOrphanCard = ({
  data,
  updateValue,
  removeValue,
  defaultItem,
}: PropsSponsorOrphanCard) => {
  const [item, setItem] = useState<any>({
    beneficiary_service_request_id: data?.id,
    amount: defaultItem?.amount ?? 0,
  });
  const [isError, setError] = useState<boolean>(false);
  const [isAdded, setIsAdded] = useState<boolean>(false);

  useEffect(() => {
    if (defaultItem) {
      setIsAdded(defaultItem.amount !== 0);
      setItem({ ...defaultItem });
    }
  }, [defaultItem]);
  const handleUpdate = (item: any) => {
    if (!isAdded && (!item.amount || parseInt(item.amount) === 0)) {
      setError(true);
    } else {
      updateValue(item);
      setIsAdded(true);
    }
  };
  const handleRemove = (item: any) => {
    setIsAdded(false);
    removeValue(item);
    setItem({ ...item, amount: 0 });
  };
  return (
    <Card className="takaful--sponsor-orphan-card-container">
      <div className="takaful--sponsor-orphan-card-content">
        <Row>
          <Col
            xxl={9}
            xl={9}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            className="takaful--sponsor-orphan-card-image"
          >
            <Row>
              <Col xxl={16} xl={16} lg={10} md={10} sm={12} xs={12}>
                <div className="takaful--sponsor-orphan-card-image-content">
                  <img width={70} src={sponsorImage} alt="" />
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={14} md={14} sm={12} xs={12}>
                <div className="takaful--sponsor-orphan-card-image-title">
                  <span>تفريج كربة</span>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xxl={15} xl={15} lg={24} md={24} sm={24} xs={24}>
            <Row gutter={[4, 4]} className="takaful--sponsor-orphan-card-row">
              <Col xxl={10} xl={12} lg={12} md={12} sm={11} xs={11}>
                <span className="takaful--sponsor-orphan-card-title">
                  المبلغ
                </span>
              </Col>
              <Col xxl={14} xl={12} lg={12} md={12} sm={13} xs={13}>
                <Row className="takaful--sponsor-orphan-card-value">
                  <Col
                    xxl={20}
                    xl={20}
                    lg={20}
                    md={20}
                    sm={20}
                    xs={20}
                    className="takaful--sponsor-orphan-card-amount"
                  >
                    {data?.amount}
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={4}
                    className="takaful--sponsor-orphan-card-currency icon-saudi_riyal"
                  >
                    
                  </Col>
                </Row>
              </Col>
              <Col xxl={10} xl={12} lg={12} md={12} sm={11} xs={11}>
                <span className="takaful--sponsor-orphan-card-title">
                  المبلغ المتبقي
                </span>
              </Col>
              <Col xxl={14} xl={12} lg={12} md={12} sm={13} xs={13}>
                <Row className="takaful--sponsor-orphan-card-value">
                  <Col
                    xxl={20}
                    xl={20}
                    lg={20}
                    md={20}
                    sm={20}
                    xs={20}
                    className="takaful--sponsor-orphan-card-amount"
                  >
                    {data?.remaining_amount}
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={4}
                    className="takaful--sponsor-orphan-card-currency icon-saudi_riyal"
                  >
                    
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Row gutter={16} style={{ padding: "1rem 0" }}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col xxl={22} xl={22} lg={22} md={22} sm={22} xs={22}>
          <ProgressCard
            percent={data?.progress}
            percentPosition={{
              align: "end",
              type: "inner",
            }}
            size={["100%", 15]}
            alternativeColor={true}
            className="takaful--sponsor-orphan-card-progress"
          />
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>

      <Row
        gutter={[4, 8]}
        className="takaful--sponsor-orphan-card-footer-container"
      >
        <Col xxl={5} xl={7} lg={5} md={5} sm={24} xs={24}>
          <span className="takaful--sponsor-orphan-card-footer">
            رقم الأسرة
          </span>
        </Col>
        <Col xxl={19} xl={17} lg={19} md={19} sm={24} xs={24}>
          <span className="takaful--sponsor-orphan-card-footer-paragraph">
            {data?.family_id}
          </span>
        </Col>
        {data?.person_id && (
          <>
            <Col xxl={5} xl={7} lg={5} md={5} sm={24} xs={24}>
              <span className="takaful--sponsor-orphan-card-footer">
                إسم المستفيد
              </span>
            </Col>
            <Col
              style={{ paddingRight: "10px" }}
              xxl={19}
              xl={17}
              lg={19}
              md={19}
              sm={24}
              xs={24}
            >
              <span className="takaful--sponsor-orphan-card-footer-paragraph">
                {data?.person_id}
              </span>
            </Col>
          </>
        )}
        <Col xxl={5} xl={7} lg={5} md={5} sm={24} xs={24}>
          <span className="takaful--sponsor-orphan-card-footer">
            نوع الخدمة
          </span>
        </Col>
        <Col xxl={19} xl={17} lg={19} md={19} sm={24} xs={24}>
          <span className="takaful--sponsor-orphan-card-footer-paragraph">
            {data?.assistance_id}
          </span>
        </Col>
        <Col xxl={5} xl={7} lg={5} md={5} sm={24} xs={24}>
          <span className="takaful--sponsor-orphan-card-footer">
            وصف الحالة
          </span>
        </Col>
        <Col xxl={19} xl={17} lg={19} md={19} sm={24} xs={24}>
          <span className="takaful--sponsor-orphan-card-footer-paragraph">
            {data?.details}
          </span>
        </Col>
      </Row>
      <Row
        justify={"space-between"}
        className="takaful--sponsor-orphan-card-button-input-container"
      >
        <Col
          xxl={12}
          xl={12}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          style={{ marginTop: "5px" }}
        >
          <div
            className={
              isError
                ? " takaful--donation-input-with-prefix takaful--input-error "
                : "takaful--donation-input-with-prefix"
            }
          >
            <Inputs
              style={{
                fontSize: "1.2rem",
                border: "none",
                height: "100%",
                borderRadius: " 0 7px 7px 0",
                width: "98%",
              }}
              type="tel"
              placeholder="ادخل المبلغ"
              value={
                item.amount === 0
                  ? ""
                  : Math.min(item.amount, data?.remaining_amount)
              }
              onChange={(e) => {
                setError(false);
                const newValue =
                  e.target.value === "" ? "" : parseInt(e.target.value);
                setItem({
                  ...item,
                  amount:
                    newValue === ""
                      ? 0
                      : Math.min(newValue, data?.remaining_amount),
                });
                if (isAdded) {
                  handleUpdate({
                    ...item,
                    amount:
                      newValue === ""
                        ? 0
                        : Math.min(newValue, data?.remaining_amount),
                  });
                }
              }}
            />
            <span className="takaful--donation-prefix icon-saudi_riyal"> </span>
          </div>
        </Col>
        <Col
          xxl={12}
          xl={12}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          style={{ marginTop: "5px" }}
        >
          <PrimaryButton
            title={isAdded ? "حذف" : "إضافة"}
            className={`takaful--sponsor-orphan-card-button ${
              isAdded && "takaful--remove"
            }`}
            onClick={() => (isAdded ? handleRemove(item) : handleUpdate(item))}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default SponsorOrphanCard;
